import React from 'react';
import Hero from './components/screen-reader/Hero';
import Main from './components/screen-reader/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const ScreenReader = () => {
  return (
    <div>
        <Hero />
        <Main />
        <ImportantLinksSlider />
    </div>
  )
}

export default ScreenReader;